import React, { useState, useEffect } from "react";
import { AiOutlineClose, AiOutlineMenu } from "react-icons/ai";

const links = [
  { label: "Home", href: "#home" },
  { label: "About", href: "#about" },
  { label: "Visit", href: "#visit" },
  { label: "Gallery", href: "#gallery" },
  { label: "Contact", href: "#contact" },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Lock body scroll while the mobile menu is open
  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  const close = () => setOpen(false);

  return (
    <>
      <header
        className={`fixed top-0 left-0 z-50 w-full transition-colors duration-300 ${
          scrolled ? "bg-maroon/95 shadow-lg backdrop-blur" : "bg-transparent"
        }`}
      >
        <nav className="mx-auto flex h-20 max-w-[1240px] items-center justify-between px-4">
          <a
            href="#home"
            className="font-serif text-xl font-bold text-white sm:text-2xl"
          >
            The Little Flock <span className="text-peach">Tabernacle</span>
          </a>

          {/* Desktop links */}
          <ul className="hidden items-center gap-1 md:flex">
            {links.map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  className="rounded-full px-4 py-2 font-medium text-white/90 transition hover:bg-white/10 hover:text-white"
                >
                  {l.label}
                </a>
              </li>
            ))}
            <li>
              <a href="#watch" className="ml-2 btn-primary px-5 py-2 text-sm">
                Watch Live
              </a>
            </li>
          </ul>

          {/* Mobile toggle */}
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-label={open ? "Close menu" : "Open menu"}
            aria-expanded={open}
            className="rounded p-2 text-white md:hidden"
          >
            {open ? <AiOutlineClose size={24} /> : <AiOutlineMenu size={24} />}
          </button>
        </nav>
      </header>

      {/* Mobile overlay — kept OUTSIDE <header> so the navbar's backdrop-blur
          doesn't become its containing block and collapse it. */}
      <div
        onClick={close}
        className={`fixed inset-0 z-[60] bg-black/60 transition-opacity duration-300 md:hidden ${
          open ? "opacity-100" : "pointer-events-none opacity-0"
        }`}
      />

      {/* Mobile slide-in panel */}
      <div
        className={`fixed top-0 left-0 z-[70] h-full w-[78%] max-w-xs bg-maroon px-6 py-6 shadow-2xl transition-transform duration-300 md:hidden ${
          open ? "translate-x-0" : "-translate-x-full"
        }`}
      >
        <div className="flex items-center justify-between">
          <span className="font-serif text-xl font-bold text-peach">
            The Little Flock
          </span>
          <button
            type="button"
            onClick={close}
            aria-label="Close menu"
            className="p-2 text-white"
          >
            <AiOutlineClose size={22} />
          </button>
        </div>
        <ul className="mt-8 flex flex-col">
          {links.map((l) => (
            <li key={l.href}>
              <a
                href={l.href}
                onClick={close}
                className="block border-b border-white/10 py-4 text-lg text-white/90 transition hover:text-peach"
              >
                {l.label}
              </a>
            </li>
          ))}
          <li className="pt-6">
            <a href="#watch" onClick={close} className="btn-primary w-full">
              Watch Live
            </a>
          </li>
        </ul>
      </div>
    </>
  );
};

export default Navbar;
